import * as React from "react";

function SvgPlay({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746zm0 1.5l-.244.004c-4.453.128-8.006 3.78-8.006 8.235l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004c4.453-.128 8.006-3.78 8.006-8.235l-.004-.255A8.248 8.248 0 0012 3.75zM9.059 9.704a1.5 1.5 0 012.264-1.291l3.881 2.295a1.5 1.5 0 010 2.583l-3.88 2.295a1.5 1.5 0 01-2.265-1.291zm1.5 0v4.591L14.442 12l-3.883-2.295z"
        />
      </g>
    </svg>
  );
}

export default SvgPlay;
